import { connect } from 'react-redux';
import UserRoleListView from './UserRoleListView';
import { fetchUserRole } from 'src/legacy/redux/actions/userRoles';
import { invalidateUserSelection } from 'src/legacy/redux/actions/selection';
import { showSettingsSideMenu, hideSettingsSideMenu }
  from 'src/legacy/redux/actions/settings.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks';
import _ from 'lodash';

const mapStateToProps = (state, ownProps) => {
  return {
    userRoles: _.get(state.legacyRootReducer, "userRoles.items", []),
    loading: _.get(state.legacyRootReducer, "settings.userGroup.loading"),
    currentPage: _.get(state.legacyRootReducer, "settings.userGroup.pagination.current"),
    totalPages: _.get(state.legacyRootReducer, "settings.userGroup.pagination.totalPages"),
    showSettingsMenu: _.get(state.legacyRootReducer, "settings.settingsMenu.showSettingsMenu"),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showSettingsSideMenu: () => {
      dispatch(showSettingsSideMenu());
    },

    hideSettingsSideMenu: () => {
      dispatch(hideSettingsSideMenu())
    },

    fetchUserRole: (id) => {
      return dispatch(fetchUserRole(id));
    },

    invalidateUserSelection: () => {
      return dispatch(invalidateUserSelection());
    }
  }
}

const UserRoleListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserRoleListView);

export default withUseHooks(UserRoleListContainer);